import { APP_CONNECTIVITY_CHANGED } from './actionTypes';

const setAppConnectivity = (isConnected) => ({
  type: APP_CONNECTIVITY_CHANGED,
  payload: isConnected,
});

export default setAppConnectivity;
